import { render, staticRenderFns } from "./JobOrders.vue?vue&type=template&id=537c16d7&scoped=true&"
import script from "./JobOrders.vue?vue&type=script&lang=js&"
export * from "./JobOrders.vue?vue&type=script&lang=js&"
import style0 from "./JobOrders.vue?vue&type=style&index=0&id=537c16d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c16d7",
  null
  
)

export default component.exports